<template>
  <div class="flex flex-col gap-0.5">
    <BaseSwitchListItem
      v-model="state.enabled"
      v-tooltip="
        locked
          ? $t('survey.perspectiveAnswered')
          : required
            ? $t('startSurvey.perspectiveRequiredTooltip')
            : undefined
      "
      :title="resolvePerspectiveLabel(perspective.key, [perspective])"
      :icon="perspective.icon"
      :disabled="required || locked"
      :supporting-text="perspective.requestFeedbackDescription"
      class="bg-surface-container-low rounded-t-large transition-all"
      :class="[state.enabled && 'rounded-b-extra-small', !state.enabled && 'rounded-b-large']"
    />
    <BaseAnimatedExtend :is-extended="state.enabled">
      <div class="flex flex-col gap-0.5">
        <BaseMemberSelect
          v-if="perspective.allowedMechanisms.includes('app_user')"
          v-model="state.appUserMemberIds"
          :error="error"
          :placeholder="$t('startSurvey.selectMembers')"
          :filter="memberFilter"
          :capability="memberCapability"
          :include-self="memberIncludeSelf"
          :filteredMemberIds="alreadySelectedMemberIds"
          :locked-member-ids="lockedMemberIds"
          background-class="container-high"
          class="bg-surface-container-low rounded-extra-small last:rounded-b-large p-4"
        />
        <div
          v-if="
            perspective.allowedMechanisms.includes('link') &&
            perspective.allowedMechanisms.length === 1
          "
          class="bg-surface-container-low rounded-extra-small last:rounded-b-large flex flex-row items-center p-4 pl-14"
        >
          <p class="text-body-medium text-on-surface-variant grow">
            {{ $t('startSurvey.openLinkDescription') }}
          </p>
          <BaseIcon size="20" class="text-on-surface-variant ml-2">qr_code</BaseIcon>
        </div>
        <BaseSwitchListItem
          v-if="
            perspective.allowedMechanisms.includes('link') &&
            perspective.allowedMechanisms.length > 1
          "
          v-model="state.useOpenLink"
          v-tooltip="openLinkLocked ? $t('survey.openLinkAnsweredTooltip') : undefined"
          :title="$t('startSurvey.openLink')"
          icon="qr_code"
          :disabled="required || openLinkLocked"
          :supporting-text="$t('startSurvey.openLinkDescription')"
          class="bg-surface-container-low last:rounded-b-large"
          :class="[state.enabled && 'rounded-b-extra-small', !state.enabled && 'rounded-b-large']"
        />
      </div>
    </BaseAnimatedExtend>
  </div>
</template>

<script setup lang="ts">
  import BaseSwitchListItem from '@/core/components/base/switch-list-item/BaseSwitchListItem.vue'
  import BaseMemberSelect from '@/core/components/base/member-select/BaseMemberSelect.vue'
  import type { Perspective, PerspectiveGatheringState } from '@/core/models/perspective'
  import BaseAnimatedExtend from '../base/animated-extend/BaseAnimatedExtend.vue'
  import BaseIcon from '../base/icon/BaseIcon.vue'
  import { resolvePerspectiveLabel } from '@/core/models/perspective-label.ts'

  interface Props {
    perspective: Perspective
    state: PerspectiveGatheringState
    required?: boolean
    error?: string
    memberFilter?: 'all' | 'coachees' | 'non-coachees'
    memberCapability?: 'canReceiveFeedback' | 'canGiveFeedback'
    memberIncludeSelf?: boolean
    alreadySelectedMemberIds?: string[]
    locked?: boolean
    openLinkLocked?: boolean
    lockedMemberIds?: string[]
  }

  withDefaults(defineProps<Props>(), {
    locked: false,
    openLinkLocked: false,
    lockedMemberIds: () => [],
  })
</script>
